'use client';

import { useCallback, useContext } from 'react';
import { EventLogger } from '@kouzoh/client-event-logger';
import { EventLoggerContext } from './EventLoggerProvider';

type Log = typeof EventLogger.prototype.log;
type FlushEvents = typeof EventLogger.prototype.flushEvents;

export const useEventLogger = () => {
  if (typeof window === 'undefined') {
    return {
      log: () => {},
      flushEvents: async () => {},
    };
  }

  const logger = useContext(EventLoggerContext);

  if (!logger) {
    throw new Error(
      'EventLoggerProvider is not found. This hooks must be used within EventLogProvider'
    );
  }

  const log: Log = useCallback(
    (...args) => {
      logger.log(...args);
    },
    [logger]
  );

  const flushEvents: FlushEvents = useCallback(
    async (timeout) => {
      await logger.flushEvents(timeout);
    },
    [logger]
  );

  return { log, flushEvents };
};
